// extracted by mini-css-extract-plugin
export default {"pageNavigation":"Pagination_pageNavigation__mx90z","navigationButton":"Pagination_navigationButton__YD-gp"};